/**
 * Flag for session automation, true for apps that are not available for
 * anonymous user.
 */
export type IRedirectAnonymousToGate = boolean;

export const RedirectAnonymousToGateProvider: {
  provide: string;
  useFactory: () => IRedirectAnonymousToGate;
} = {
  provide: 'redirectAnonymousToGate',
  // Note! useValue, will not allow useFactory (as used in www) to override it
  useFactory: () => true,
};
